const UTM_SESSION_KEY = "ssf-utm";
const GCLID_SESSION_KEY = "ssf-gclid";
const REFERRER_SESSION_KEY = "ssf-referrer";

function getSessionStorageValue(key: string): string | null {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    return window.sessionStorage.getItem(key);
  } catch {
    return null;
  }
}

function setSessionStorageValue(key: string, value: string) {
  if (typeof window === "undefined") {
    return;
  }

  try {
    window.sessionStorage.setItem(key, value);
  } catch {
    // Ignore storage errors (e.g. blocked storage).
  }
}

export function initMarketingSession(): void {
  if (typeof window === "undefined") {
    return;
  }

  const storedUtm = getSessionStorageValue(UTM_SESSION_KEY);
  if (storedUtm === null) {
    try {
      const params = new URLSearchParams(window.location.search);
      const utm = params.get("utm") ?? "";
      setSessionStorageValue(UTM_SESSION_KEY, utm);
    } catch {
      setSessionStorageValue(UTM_SESSION_KEY, "");
    }
  }

  const storedGclid = getSessionStorageValue(GCLID_SESSION_KEY);
  if (storedGclid === null) {
    try {
      const params = new URLSearchParams(window.location.search);
      const gclid = params.get("gclid") ?? "";
      setSessionStorageValue(GCLID_SESSION_KEY, gclid);
    } catch {
      setSessionStorageValue(GCLID_SESSION_KEY, "");
    }
  }

  const storedReferrer = getSessionStorageValue(REFERRER_SESSION_KEY);
  if (storedReferrer === null) {
    const referrer = document.referrer ?? "";
    setSessionStorageValue(REFERRER_SESSION_KEY, referrer);
  }
}

export function getUtmParam(): string {
  if (typeof window === "undefined") {
    return "";
  }

  const storedUtm = getSessionStorageValue(UTM_SESSION_KEY);
  if (storedUtm !== null) {
    return storedUtm;
  }

  try {
    const params = new URLSearchParams(window.location.search);
    const utm = params.get("utm") ?? "";

    setSessionStorageValue(UTM_SESSION_KEY, utm);

    return utm;
  } catch {
    setSessionStorageValue(UTM_SESSION_KEY, "");

    return "";
  }
}

export function getGclidParam(): string {
  if (typeof window === "undefined") {
    return "";
  }

  const storedGclid = getSessionStorageValue(GCLID_SESSION_KEY);
  if (storedGclid !== null) {
    return storedGclid;
  }

  try {
    const params = new URLSearchParams(window.location.search);
    const gclid = params.get("gclid") ?? "";

    setSessionStorageValue(GCLID_SESSION_KEY, gclid);

    return gclid;
  } catch {
    setSessionStorageValue(GCLID_SESSION_KEY, "");

    return "";
  }
}

export function getReferrer(): string {
  if (typeof window === "undefined") {
    return "";
  }

  const storedReferrer = getSessionStorageValue(REFERRER_SESSION_KEY);
  if (storedReferrer !== null) {
    return storedReferrer;
  }

  const referrer = document.referrer ?? "";
  setSessionStorageValue(REFERRER_SESSION_KEY, referrer);

  return referrer;
}

export function getGAClientId(): string {
  const cookie: Record<string, string> = {};
  if (typeof window === "undefined") {
    return "";
  }
  document.cookie.split(";").forEach((el) => {
    const splitCookie = el.split("=");
    const key = splitCookie[0].trim();
    const value = splitCookie[1];
    if (key && value) {
      cookie[key] = value;
    }
  });
  if (cookie["_ga"]) {
    return cookie["_ga"].substring(6);
  }

  return "";
}
